import { render, staticRenderFns } from "./BrandFilter.vue?vue&type=template&id=1787cd1e&scoped=true&"
import script from "./BrandFilter.vue?vue&type=script&lang=js&"
export * from "./BrandFilter.vue?vue&type=script&lang=js&"
import style0 from "./BrandFilter.vue?vue&type=style&index=0&id=1787cd1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1787cd1e",
  null
  
)

export default component.exports